import { useState } from "react";
import { categoryService } from "./categoryService";
import { notifyError, notifySuccess } from "../../../../../assets/toastService";

export const useCategoryActions = () => {
  const [loading, setLoading] = useState(false);

  const createCategory = async (categoryData: { CategoryName: string; Type: string }) => {
    setLoading(true);
    try {
      const data = await categoryService.create(categoryData);
      notifySuccess("Category added successfully");
      return data;
    } catch (error: any) {
      if (error.response?.status === 409) {
        notifyError("Category already exists");
      } else {
        notifyError("Failed to create category");
      }
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const updateCategory = async (id: string, categoryData: { CategoryName: string; Type?: string }) => {
    setLoading(true);
    try {
      const data = await categoryService.update(id, categoryData);
      notifySuccess("Category updated successfully");
      return data;
    } catch (error: any) {
      if (error.response?.data?.message?.includes("already exists")) {
        notifyError("Category name already exists");
      } else {
        notifyError("Failed to update category");
      }
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const deleteCategory = async (id: string) => {
    setLoading(true);
    try {
      const data = await categoryService.delete(id);
      notifySuccess("Category deleted successfully");
      return data;
    } catch (error) {
      notifyError("Failed to delete category");
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { loading, createCategory, updateCategory, deleteCategory };
};
